import {
  Alert,
  Modal,
  ModalContent,
  ModalFooter,
  useToaster
} from "@dealer-center/core-components";
import { SaveAndCancel } from "@dealer-center/core-custom-components";
import { useDeleteFranchise } from "@dealer-center/ddc-pages-franchise-management-fetch";
import { useEffect } from "react";

interface FranchiseDeleteModalProps {
  values: {
    id: string;
    name: string;
  };
  show: boolean;
  close: () => void;
}

export const FranchiseDeleteModal = ({
  close,
  values,
  show
}: FranchiseDeleteModalProps) => {
  const { name, id } = values;
  const { toastError, toastSuccess } = useToaster();
  const { mutate, isError, isSuccess, isPending, error } = useDeleteFranchise();

  useEffect(() => {
    if (isError) {
      console.log("error", error);

      // Parse error response for very short user-friendly messages
      let errorMessage = "Error deleting franchise";

      if (error?.message?.includes("400")) {
        errorMessage = "Franchise has active accounts";
      } else if (error?.message?.includes("404")) {
        errorMessage = "Franchise not found";
      } else if (error?.message?.includes("403")) {
        errorMessage = "Access denied";
      }

      toastError(errorMessage);
      close();
    }
    if (isSuccess) {
      toastSuccess("Success", `Franchise deleted`);
      close();
    }
  }, [isError, isSuccess, close, toastError, toastSuccess, name, error]);

  return (
    <Modal
      className="sample-modal-dialog"
      footer={{
        primary: { label: "unused" },
        footerComponent: (
          <ModalFooter>
            <SaveAndCancel
              analyticsEventName="Franchise Delete"
              isDisabled={isPending}
              isSaving={isPending}
              saveButtonText="Delete"
              onCancel={close}
              onSave={() => {
                // Optimistic update will happen immediately via onMutate
                mutate(id || "");
              }}
            />
          </ModalFooter>
        )
      }}
      header={`Delete Franchise "${name}"`}
      show={show}
      size="small"
      onHide={close}
    >
      <ModalContent>
        <Alert role="alert" sx={{ marginBottom: "16px" }} type="error">
          Are you sure you want to delete this franchise? This action cannot be
          undone.
        </Alert>
      </ModalContent>
    </Modal>
  );
};
